export type AIProvider = 'claude' | 'gemini' | 'pollinations';

export interface AITextResult {
  text: string;
  provider: AIProvider;
}

export class AIError extends Error {
  provider: AIProvider;
  retryable: boolean;

  constructor(provider: AIProvider, message: string, retryable = false) {
    super(message);
    this.name = 'AIError';
    this.provider = provider;
    this.retryable = retryable;
    Object.setPrototypeOf(this, AIError.prototype);
  }
}

// Claude declined this one request. It says nothing about the key or the account, so other requests can go on.
export class ClaudeRefusalError extends AIError {
  constructor() {
    super('claude', 'Claude declined this request.');
    Object.setPrototypeOf(this, ClaudeRefusalError.prototype);
  }
}

export const describeAIError =(err: unknown): string =>
  err instanceof Error ? err.message : String(err);

// Claude calls are billed per attempt and the SDK already retries transient failures,
// so automatic retry loops only apply to the free providers.
export const shouldAutoRetry = (err: unknown): boolean => {
  if (err instanceof AIError) {
    return err.provider !== 'claude' && err.retryable;
  }
  return true;
};

export const SYSTEM_PROMPT =
  'You are a professional assistant for Israeli content creators. Follow instructions perfectly and output exactly what is asked.';
